export default __webpack_public_path__ + "images/c4326840f2ae1ebcb4822d0317aeab7e.svg";